// src/store/api/axiosPublic.js
import axios from "axios";

export const baseURLNew = "https://apilead.blaccdot.ae/api/";

const axiosPublic = axios.create({
  baseURL: baseURLNew,
});

export default axiosPublic;
